import Vue from 'vue';

export default {
    get(slug) {
        return Vue.axios.get(`page/${slug}`);
    }
};
